import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";
import { apiRequest } from "../app2.js/store/allApi";

const firebaseConfig = {
  apiKey: "AIzaSyDPCgvnSk8WyO6KrDYfLyHCwwZqPd9P988",
  authDomain: "Empireludo-ab00c.firebaseapp.com",
  projectId: "Empireludo-ab00c",
  storageBucket: "Empireludo-ab00c.firebasestorage.app",
  messagingSenderId: "758308593105",
  appId: "1:758308593105:web:ed1690eea0107a7d3c14f0",
  measurementId: "G-DERE6CRLRM",
};

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
const db = getFirestore(app);

async function saveTokenToServer(currentToken) {
  const access_token = localStorage.getItem("token");
  const fcm = localStorage.getItem("fcm");
  if (!access_token || !currentToken || fcm === currentToken) return;

  try {
    await apiRequest(
      `updateToken?firebaseToken=${encodeURIComponent(currentToken)}`,
      "GET"
    );
    localStorage.setItem("fcm", currentToken);
  } catch (e) {
    console.error("FCM updateToken failed:", e?.response?.data || e.message || e);
  }
}

export const getTokens = async (setTokenFound) => {
  try {
    if (typeof Notification === "undefined") {
      if (typeof setTokenFound === "function") setTokenFound(false);
      return;
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission not granted:", permission);
      if (typeof setTokenFound === "function") setTokenFound(false);
      return;
    }

    const currentToken = await getToken(messaging, {
      vapidKey:
        "BFwWowecyp38AcnPsuY29GgPx9RZytrWEFS_mP5wqbtdQGOJkBLSAQp9xbBLDy7fkakqcNTOQZ2XW2BIcPZ3ERk",
    });

    if (currentToken) {
      await saveTokenToServer(currentToken);
      if (typeof setTokenFound === "function") {
        setTokenFound({ status: true, token: currentToken });
      }
    } else {
      console.warn("No FCM registration token available.");
      if (typeof setTokenFound === "function") setTokenFound(false);
    }
  } catch (err) {
    console.error("getTokens error:", err);
    if (typeof setTokenFound === "function") setTokenFound(false);
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export { db };
